import { FileTypes } from 'src/features/common/components/file-upload/file-upload';
import { ImageUploadJourney } from '../context/image-upload-context';
import { DocumentWithOptionalBody, IdItem, OnboardingDocumentTypeEnum } from './upload-documents';

export enum ImageUploadActionType {
  INIT_DOCUMENTS = 'initialize-documents',
  UPDATE_DOCUMENTS = 'update-documents',
  REMOVE_DOCUMENTS = 'remove-documents',
  UPDATE_CURRENT_DOCUMENTS = 'update-current-documents',
  //use when revampDocUploadEnabled is disabled
  ADD_ID_DOCS = 'add-id-docs',
  REMOVE_ID_DOCS = 'remove-id-docs',
  SET_ALLOWED_FILE_TYPES = 'set-allowed-file-types', // Used  to cater to iOS
  SET_STEP_INDEX = 'set-step-index',

  // Select ID type
  SELECT_ID_TYPE = 'select-id-type',
  END_SELECT_ID_TYPE = 'end-select-id-type',
  CLOSE_SELECT_ID_TYPE = 'close-select-id-type',

  // Upload photo ( id guide modal)
  INIT_UPLOAD_PHOTO = 'initialize-upload-photo',
  UPDATE_UPLOAD_PHOTO = 'update-upload-photo',
  RETRY_UPLOAD_PHOTO = 'retry-upload-photo',
  CLOSE_TAKE_PHOTO = 'close-take-photo',
  END_TAKE_PHOTO_PROMPT = 'end-take-photo-prompt',

  //  Take photo (id guide modal)
  INIT_TAKE_PHOTO = 'initialize-take-photo',
  RETAKE_PHOTO = 'retake-photo',
  TAKE_PHOTO = 'take-photo',
  UPDATE_TAKE_PHOTO = 'update-take-photo',

  // take/upload photo
  SUBMIT_PHOTO = 'submit-photo',

  ADD_SELECT_FILES = 'add-selected-files', // Used  to cater to iOS

  // Take photo tip modal
  TAKE_PHOTO_TIP = 'take-photo-tip',
  END_TAKE_PHOTO_TIP = 'end-take-photo-tip',
}

// Documents
export type InitDocumentsStep = {
  type: ImageUploadActionType.INIT_DOCUMENTS;
  initialDocs: DocumentWithOptionalBody[];
  ids: IdItem[];
  refugeeIds: IdItem[];
  asylumIds: IdItem[];
};

export type UpdateDocumentsStep = {
  type: ImageUploadActionType.UPDATE_DOCUMENTS;
  docs: DocumentWithOptionalBody[];
  currentDocs?: DocumentWithOptionalBody[];
};

export type RemoveDocumentStep = {
  type: ImageUploadActionType.REMOVE_DOCUMENTS;
  docs: DocumentWithOptionalBody[];
  fileToRemove?: DocumentWithOptionalBody;
};

export type UpdateCurrentDocumentsStep = {
  type: ImageUploadActionType.UPDATE_CURRENT_DOCUMENTS;
  docs: DocumentWithOptionalBody[];
};

export type AddIdDocsStep = {
  type: ImageUploadActionType.ADD_ID_DOCS;
  doc: DocumentWithOptionalBody;
};

export type RemoveIdDocsStep = {
  type: ImageUploadActionType.REMOVE_ID_DOCS;
  fileToRemove?: DocumentWithOptionalBody;
};

export type SetAllowedFileTypesStep = {
  type: ImageUploadActionType.SET_ALLOWED_FILE_TYPES;
  allowedFileTypes: FileTypes[];
  maxFileSize: number;
};
export type SetStepIndexStep = {
  type: ImageUploadActionType.SET_STEP_INDEX;
  stepIndex: number;
};

// Select ID type
export type SelectIdTypeStep = {
  type: ImageUploadActionType.SELECT_ID_TYPE;
  journey: ImageUploadJourney;
  showSelectIdType: boolean;
  documentType?: OnboardingDocumentTypeEnum;
};

export type EndSelectIdTypeStep = {
  type: ImageUploadActionType.END_SELECT_ID_TYPE;
  showModal: boolean;
  requestBothSides: boolean;
  idNumber: string;
  idDocType: OnboardingDocumentTypeEnum;
  openCamera: boolean;
};

export type CloseSelectIdTypeStep = {
  type: ImageUploadActionType.CLOSE_SELECT_ID_TYPE;
  showModal: boolean;
  idNumber: string;
};

// Upload photo ( id guide modal)
export type InitUploadPhotoStep = {
  type: ImageUploadActionType.INIT_UPLOAD_PHOTO;
  uploadPhoto: boolean;
};

export type RetryUploadPhotoStep = {
  type: ImageUploadActionType.RETRY_UPLOAD_PHOTO;
  uploadPhoto: boolean;
};

export type UpdateTakePhotoPromptStep = {
  type: ImageUploadActionType.UPDATE_TAKE_PHOTO;
  documents: DocumentWithOptionalBody[];
};

export type SubmitPhotoStep = {
  type: ImageUploadActionType.SUBMIT_PHOTO;
  documents: DocumentWithOptionalBody[];
  stepIndex: number;
  openCamera?: boolean;
};

export type CloseTakePhotoStep = {
  type: ImageUploadActionType.CLOSE_TAKE_PHOTO;
  showModal: boolean;
  documents: DocumentWithOptionalBody[];
};

export type EndTakePhotoPromptStep = {
  type: ImageUploadActionType.END_TAKE_PHOTO_PROMPT;
};

// Used  to cater to iOS
export type AddSelectedFilesStep = {
  type: ImageUploadActionType.ADD_SELECT_FILES;
  selectedFile: File;
};

// Take Photo (id guide modal)
export type InitTakePhotoStep = {
  type: ImageUploadActionType.INIT_TAKE_PHOTO;
  takePhoto: boolean;
  imageSrc: string;
  stepIndex: number;
};

export type TakePhotoStep = {
  type: ImageUploadActionType.TAKE_PHOTO;
  imageSrc: string;
};

export type RetakePhotoStep = {
  type: ImageUploadActionType.RETAKE_PHOTO;
};

export type UpdateTakePhotoStep = {
  type: ImageUploadActionType.UPDATE_TAKE_PHOTO;
  takePhoto: boolean;
};

// Take Photos tips Modal
export type TakePhotoTipStep = {
  type: ImageUploadActionType.TAKE_PHOTO_TIP;
  showModal: boolean;
  documentType?: OnboardingDocumentTypeEnum;
};

export type EndTakePhotoTipStep = {
  type: ImageUploadActionType.END_TAKE_PHOTO_TIP;
  showModal?: boolean;
  openCamera: boolean;
};
